export default "__VITE_ASSET__BJP815UM__"